import { SingleSelectField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { AppNotificationStatus } from "../shared/types/appNotification";

interface Props {
	name: string;
	label: string;
	disabled?: boolean;
}

const options: AppNotificationStatus[] = ["error", "sent", "scheduled"];

export const AppNotificationStatusSelect: FC<Props> = ({ name, label, disabled }) => {
	const { t } = useTranslation();

	return (
		<SingleSelectField
			label={label}
			name={name}
			options={options}
			getLabel={(status) => t(status)}
			getValue={String}
			disabled={disabled}
		/>
	);
};
